import React, { useCallback, forwardRef } from 'react';
import { css, cx } from '@emotion/css';
import colors from '@/theme/colors';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onClick?: () => void;
  role?: React.AriaRole | undefined;
}

export const AccessibleDivButton = forwardRef<HTMLDivElement, Props>(
  ({ role = 'button', onClick, className, children, ...rest }, ref) => {
    const handleKeyDown = useCallback(
      (event: React.KeyboardEvent<HTMLDivElement>) => {
        if ((event.key === 'Enter' || event.key === ' ') && onClick) {
          event.preventDefault();
          onClick();
        }
      },
      [onClick]
    );

    return (
      <div
        ref={ref}
        role={role}
        tabIndex={0}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        className={cx(buttonStyle, className)}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

const buttonStyle = css`
  cursor: pointer;
  outline: none;
  transition: box-shadow 0.3s ease;
  display: inline-flex;

  &:focus-visible {
    box-shadow: 0 0 0 2px ${colors.focusOutlineColor};
  }

  &:focus:not(:focus-visible) {
    outline: none;
    box-shadow: none;
  }
`;
